import React from "react";
import { Card, Col, Row, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ReactFancyBox from "react-fancybox";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";

const Details = ({ item, moduleConfig }) => {
  const getCustomer = () => {
    let items = [];

    if (item.customer && item?.customer?.fullName) {
      items = [
        ...items,
        {
          text: "Full Name",
          value: item?.customer?.fullName,
          type: "text",
        },
      ];
    }
    if (item.customer && item.customer.email) {
      items = [
        ...items,
        { text: "Email", value: item.customer.email, type: "email" },
      ];
    }
    if (item.guestEmail) {
      items = [
        ...items,
        { text: "Email", value: item.guestEmail, type: "email" },
      ];
    }

    return items;
  };
  return (
    <>
      <Row>
        <Col>
          <Card className="item mb-1 borderCream">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="d-flex m-0 p-0">
                <div className="d-flex ImageSectionSpacing">
                  {/* <div className="checkboxCol me-2 ms-2 mt-2">
              <input
                type="checkbox"
                id={item._id}
                name={item._id}
                onChange={handleCheckBoxClick}
                checked={isCheck.includes(item._id)}
              />
            </div> */}

                  <div className="ms-1 me-2">
                    <i className="fa fa-shopping-cart pt-1 position-relative cartIcon "></i>
                  </div>

                  <div className="d-flex flex-column align-items-start justify-content-center ms-1">
                    <span className="m-0 text-bold text-red">
                      {" "}
                      {/* <a href={`/buyers/${item._id}`} className="hoveredText">
                  {item.customer.fullName ? item.customer.fullName : getFullName(item.customer)}
                </a> */}
                      {item.cartItems && item.cartItems.length} Item(s) in cart
                    </span>

                    <span className="">
                      <span className="text-custom-4 mt-1 small  text-bold">
                        {item.orderType}
                      </span>
                    </span>
                  </div>
                </div>
              </Card.Title>

              <div className="card-tools endColumn mb-1 pt-1">
                <div>
                  {(item.paymentFailed === "1" || item.paymentFailed === 1) && (
                    <span className="badge red me-1 text-white">
                      Payment Failed
                    </span>
                  )}
                  {item.paymentMethod && (
                    <span className="badge badge-info me-1 text-white">
                      Online Payment Selected
                    </span>
                  )}

                  {item.createdAt && (
                    <span className="badge badge-light me-1 text-dark">
                      Created Date :{" "}
                      <span className="text-secondary">
                        <ModuleDisplayDate value={item.createdAt} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>
            <Card.Body className="p-1">
              <Row>
                <Col className="mt-1 mb-1 ">
                  <div className="d-flex">
                    <StatsListing items={getCustomer()} />
                  </div>
                </Col>
              </Row>

              {item.cartItems && item.cartItems.length > 0 && (
                <Card
                  className={`border-0 shadow-sm hover:shadow-md transition-shadow mb-1 mx-1 ${
                    item.cartItems.length > 1 ? "w-100" : "w-50"
                  }`}
                  style={{ backgroundColor: "#fffaf5ff" }}
                >
                  <Card.Header className="py-2 px-3 border-0 bg-custom-6 rounded-t-lg">
                    <h6 className="text-md text-white mb-0 fw-bold">
                      <i className="fas fa-box-open me-2 text-white"></i>
                      Cart
                    </h6>
                  </Card.Header>

                  <Card.Body className="mb-0 p-1">
                    <Row>
                      {item.cartItems.map((product, index) => {
                        const colProps =
                          item.cartItems.length === 1
                            ? { xl: 12, lg: 12, md: 12, sm: 12 }
                            : { xl: 4, lg: 6, md: 6, sm: 12 };

                        return (
                          <Col key={index} {...colProps} className="mb-2">
                            <div
                              className="border rounded bg-white shadow-sm h-100 p-2 d-flex align-items-start"
                              style={{
                                borderColor: "#f3e2c6",
                                backgroundColor: "#fffaf5",
                              }}
                            >
                              {/* Product Image */}
                              <div className="cartImage me-2 mb-1 flex-shrink-0">
                                <ReactFancyBox
                                  thumbnail={
                                    process.env.REACT_APP_BACKEND_URL +
                                    "public/" +
                                    product.image
                                  }
                                  image={
                                    process.env.REACT_APP_BACKEND_URL +
                                    "public/" +
                                    product.image
                                  }
                                  caption={product.title}
                                />
                              </div>

                              {/* Product Info */}
                              <div className="flex-grow-1">
                                <Link
                                  to={`/products/${product._id}`}
                                  className="text-bold text-decoration-none text-dark"
                                >
                                  {product.title}
                                </Link>

                                <div className="small text-muted mt-1">
                                  {product.brand && (
                                    <span>{product.brand}</span>
                                  )}
                                </div>

                                {/* Price */}
                                <div className="mt-1 position-relative">
                                  {product?.salePrice?.$numberDecimal ? (
                                    <>
                                      <span className="fw-bold text-custom-4 me-1">
                                        {product.salePrice.$numberDecimal}{" "}
                                        {getCurrencyCode()}
                                      </span>
                                      {product?.price?.$numberDecimal && (
                                        <small
                                          className="text-muted text-decoration-line-through"
                                          style={{ position: "absolute" }}
                                        >
                                          {product.price.$numberDecimal}{" "}
                                          {getCurrencyCode()}
                                        </small>
                                      )}
                                    </>
                                  ) : (
                                    <span className="fw-bold text-primaryCream">
                                      {product.price?.$numberDecimal}{" "}
                                      {getCurrencyCode()}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </Card.Body>
                </Card>
              )}

              {/* ========================== PAYMENT SECTION ========================== */}
              {item.payment && item.payment.length > 0 && (
                <Row className="mt-3">
                  <Col>
                    <h6 className="text-dark fw-bold mb-2">
                      <i className="fas fa-credit-card me-2 text-custom-2"></i>
                      Payment Details
                    </h6>
                    <div className="border rounded bg-light p-2">
                      {item.payment.map((pay, idx) => (
                        <div
                          key={idx}
                          className="d-flex justify-content-between border-bottom py-1"
                        >
                          <span>
                            <strong>Method:</strong> {pay.method || "-"}
                          </span>
                          <span>
                            <strong>Amount:</strong> ₹
                            {pay.amount?.$numberDecimal || "0"}
                          </span>
                          <span>
                            <strong>Status:</strong> {pay.status || "N/A"}
                          </span>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
